import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Plus, MinusCircle, Brain, Coins, GraduationCap } from '@phosphor-icons/react';

const ACTIONS = [
  { key: 'buy',    label: 'Buy Stock',  to: '/market',     icon: Plus,        gradient: 'from-yellow-400 to-yellow-600', text: 'text-black' },
  { key: 'sell',   label: 'Sell Shares',to: '/portfolio',  icon: MinusCircle, gradient: 'from-zinc-700 to-zinc-800',     text: 'text-white' },
  { key: 'ai',     label: 'AI Analyst', to: '/dashboard#ai', icon: Brain,     gradient: 'from-cyan-400 to-blue-500',     text: 'text-black' },
  { key: 'bet',    label: 'Create Bet', to: '/bets',       icon: Coins,       gradient: 'from-amber-400 to-amber-600',   text: 'text-black' },
  { key: 'learn',  label: 'Learn',      to: '/learn',      icon: GraduationCap, gradient: 'from-purple-500 to-purple-700', text: 'text-white' },
];

const QuickActions = ({ onAiClick }) => {
  const navigate = useNavigate();

  const handle = (action) => {
    if (action.key === 'ai' && onAiClick) {
      onAiClick();
      return;
    }
    navigate(action.to.replace('#ai', ''));
  };

  return (
    <div className="mb-6" data-testid="quick-actions">
      <h3 className="text-xs uppercase tracking-wider text-zinc-500 mb-3">Quick Actions</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
        {ACTIONS.map((action) => {
          const Icon = action.icon;
          return (
            <motion.button
              key={action.key}
              whileHover={{ y: -3, scale: 1.02 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => handle(action)}
              className={`flex flex-col items-center justify-center gap-1.5 p-3 rounded-xl bg-gradient-to-br ${action.gradient} ${action.text} font-semibold text-sm shadow-md hover:shadow-xl transition-shadow`}
              data-testid={`quick-action-${action.key}`}
            >
              <Icon size={22} weight="fill" />
              <span className="text-xs">{action.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
